<template>
  <div class="m-avatar">
    <div class="w-100 d-flex align-items-center">
      <template v-if="userinfos != null">
        <div class="justify-content-center">
          <div class="avatar-frame big">
            <img :src="showavatar" class="img-fluid">
          </div>
        </div>
        <div class="w-100 ml-4">
          <div>{{ $translate("Phywe::Template.avatarHelloUser") }}</div>
          <div class="font-weight-bold">
            <span v-html="showuser.firstName"></span>
            <span v-html="showuser.lastName"></span>
          </div>
          <div class="d-flex">
            <div>
              <a :href="myaccount">
                <i class="icon-edit-black"></i>
              </a>
            </div>
            <div>
              <a :href="wishlist">
                <i class="icon-wishlist_show-black"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="justify-content-center">
          <div class="avatar-frame big">
            <img src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/MyAccount/No-Image-85x85.jpg" class="img-fluid">
          </div>
        </div>
        <div class="w-100 ml-4"><div>{{ $translate("Phywe::Template.avatarHelloGuest") }}</div><a class="font-weight-bold link-black" :href="userlogin">{{ $translate("Phywe::Template.avatarRegister") }}</a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default
{
  props: ['lang'],
  data: function()
  {
    return {
      user:'',
      image:'',
      userinfos:null
    };
  },
  mounted: function()
  {
    this.$nextTick(() =>
    {
      let _self = this;
      _self.userinfos = this.$store.state.user.userData;
      if(this.userinfos != null)
      {
        _self.getCurrentAvatar(this.userinfos.id);
      }
    })
  },
  methods:
      {
        getCurrentAvatar:function (id)
        {
          let _self = this;
          let myuser = this.user;
          $.ajax(
              {
                type:           'GET',
                url:            '/'+App.language+'/avatar/get/'+ id + '/' + App.language+ '/',
                dataType:       'json',
                success:        function(data)
                {
                  _self.image = data.body;
                },
                error:          function(jqXHR, textStatus, errorThrown)
                {
                  console.error(errorThrown);
                }
              });
          _self.user = ceresStore.state.user.userData;
        }

      },
  computed:
  {
    userlogin:function()
    {
      return App.urls.login;
    },
    myaccount:function()
    {
      return App.urls.myAccount;
    },
    wishlist:function()
    {
      return App.urls.wishList
    },
    showavatar: function()
    {
      let _self = this;
      return _self.image
    },
    showuser: function()
    {
      let _self = this;
      return _self.user;
    }
  }
}
</script>
